// ============================================================
//  paths.js — Helpers para rutas multi-tenant.
//  El primer segmento de la URL puede ser el slug de un cliente.
//  Estas funciones permiten construir rutas y la URL del backend
//  manteniendo el slug activo.
// ============================================================

// Segmentos reservados: NO se tratan como slug de cliente.
const RESERVED = [
    'registros',
    'master',
    'dashboard',
    'trabajador',
    'productos',
    'producto',
    'qr',
    'backend',
    'api',
];

export function getTenantSlug() {
    if (typeof window === 'undefined') return '';
    const parts = window.location.pathname.split('/').filter(Boolean);
    const first = (parts[0] || '').toLowerCase();
    if (!first || RESERVED.includes(first)) return '';
    return first;
}

export function basePath() {
    const slug = getTenantSlug();
    return slug ? '/' + slug : '';
}

export function ruta(path) {
    return basePath() + path;
}
